<template>
  <div v-if="tournaments">
    <md-list class="top-tools">
      <md-toolbar>
        <h1 class="md-title">{{title}}</h1>
        <div class="md-toolbar-section-end">
          <md-button
            v-if="currentUser"
            class="md-fab md-mini md-accent"
            @click="showCreateTournamentDialog = true"
          >
            <md-icon>add</md-icon>
            <md-tooltip>Create a new tournament</md-tooltip>
          </md-button>
          <md-button class="md-icon-button" @click="refetch()">
            <md-icon>refresh</md-icon>
          </md-button>
        </div>
      </md-toolbar>

      <md-list-item md-expand>
        <md-icon>filter_list</md-icon>
        <span class="md-list-item-text">Options</span>

        <md-list slot="md-expand" class="flex-container">
          <md-list-item class="md-inset flex-item">
            <md-switch v-model="showThisMonth">This Month</md-switch>
          </md-list-item>
          <md-list-item class="md-inset flex-item">
            <md-switch v-model="showNextMonth">Next Month</md-switch>
          </md-list-item>
          <md-list-item class="md-inset flex-item">
            <md-switch v-model="showFuture">Future</md-switch>
          </md-list-item>
          <md-list-item class="md-inset flex-item">
            <md-switch v-model="showOlder">Older</md-switch>
          </md-list-item>
        </md-list>
      </md-list-item>
    </md-list>

    <!-- The match listings -->
    <div class="flex-container">
      <TournamentList
        v-if="showThisMonth"
        :title="thisMonthTitle"
        :tournaments="thisMonthTournaments"
        class="flex-item"
      />
      <TournamentList
        v-if="showNextMonth"
        :title="nextMonthTitle"
        :tournaments="nextMonthTournaments"
        class="flex-item"
      />
      <TournamentList
        v-if="showFuture"
        title="Future"
        :tournaments="futureTournaments"
        class="flex-item"
      />
      <TournamentList
        v-if="showOlder"
        title="Older"
        :tournaments="olderTournaments"
        class="flex-item"
      />
    </div>
    <UpsertTournamentDialog
      :show="showCreateTournamentDialog"
      @onClose="showCreateTournamentDialog = false"
    />
  </div>
  <div v-else>
    <md-progress-spinner class="wait" :md-diameter="100" :md-stroke="10" md-mode="indeterminate"/>
  </div>
</template>

<style lang="scss" scoped>
.flex-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.flex-item {
  display: flex;
  flex-direction: column;
  flex-basis: 100%;
  flex: 1;
}

.top-tools {
  padding-top: 0px !important;
}

.wait {
  margin: 2em;
}
</style>

<script>
import moment from "moment";
import UpsertTournamentDialog from "@/components/dialogs/upsertTournamentDialog.vue";
import TournamentList from "./tournamentList.vue";

function tournamentSorter(a, b) {
  return new Date(a.startDate) - new Date(b.startDate);
}

export default {
  name: "Tournaments",
  components: { UpsertTournamentDialog, TournamentList },
  props: {
    title: String,
    tournaments: Array
  },
  data: () => ({
    showCreateTournamentDialog: false
  }),
  computed: {
    showThisMonth: {
      get() {
        return this.$store.state.showThisMonth;
      },
      set(value) {
        this.$store.commit("setShowThisMonth", value);
      }
    },
    showNextMonth: {
      get() {
        return this.$store.state.showNextMonth;
      },
      set(value) {
        this.$store.commit("setShowNextMonth", value);
      }
    },
    showFuture: {
      get() {
        return this.$store.state.showFuture;
      },
      set(value) {
        this.$store.commit("setShowFuture", value);
      }
    },
    showOlder: {
      get() {
        return this.$store.state.showOlder;
      },
      set(value) {
        this.$store.commit("setShowOlder", value);
      }
    },

    currentUser: {
      get() {
        return this.$store.state.currentUser;
      }
    },
    thisMonthTitle: {
      get() {
        return `${moment().format("MMMM YYYY")} Tournaments`;
      }
    },
    nextMonthTitle: {
      get() {
        return `${moment()
          .add(1, "M")
          .format("MMMM YYYY")} Tournaments`;
      }
    },
    thisMonthTournaments: {
      get() {
        const d = moment().startOf("month");
        return this.tournaments
          .filter(
            x =>
              x.startDate &&
              moment(x.startDate)
                .startOf("month")
                .isSame(d)
          )
          .sort(tournamentSorter);
      }
    },
    nextMonthTournaments: {
      get() {
        const d = moment()
          .add(1, "M")
          .startOf("month");
        return this.tournaments
          .filter(
            x =>
              x.startDate &&
              moment(x.startDate)
                .startOf("month")
                .isSame(d)
          )
          .sort(tournamentSorter);
      }
    },
    olderTournaments: {
      get() {
        const d = moment().startOf("month");
        return this.tournaments
          .filter(x => x.startDate && moment(x.startDate) < d)
          .sort(tournamentSorter)
          .reverse();
      }
    },
    futureTournaments: {
      get() {
        const d = moment()
          .add(1, "M")
          .endOf("month");
        return this.tournaments
          .filter(x => !x.startDate || moment(x.startDate) > d)
          .sort(tournamentSorter);
      }
    }
  }
};
</script>




// WEBPACK FOOTER //
// tournaments.vue?2936f52c